// @flow
export const AUTOMATIC = "AUTOMATIC";
export const MANUAL = "MANUAL";
export const USER_ACKNOWLEDGMENT = "USER_ACKNOWLEDGMENT";
export const POTENTIAL_LEAVERS = "POTENTIAL_LEAVERS";
export const UNABLE_TO_ALLOCATE_DEPARTMENT = "UNABLE_TO_ALLOCATE_DEPARTMENT";
export const UNABLE_TO_ALLOCATE_STAFF_GROUP = "UNABLE_TO_ALLOCATE_STAFF_GROUP";
export const UNABLE_TO_ALLOCATE_SHIFT_PATTERN = "UNABLE_TO_ALLOCATE_SHIFT_PATTERN";
export const PAST_OR_CURRENT_LEAVERS_WITH_OPEN_ABSENCE =
  "PAST_OR_CURRENT_LEAVERS_WITH_OPEN_ABSENCE";
export const FUTURE_LEAVERS_WITH_OPEN_ABSENCE = "FUTURE_LEAVERS_WITH_OPEN_ABSENCE";
export const EMAIL_ADDRESS_THAT_WILL_BE_DELETED = "EMAIL_ADDRESS_THAT_WILL_BE_DELETED";

export const BLOCKED = "BLOCKED";
export const ALLOWED = "ALLOWED";
export const DEFAULT_VALUE = "DEFAULT_VALUE";

export const DATA_FILE_TYPES = {
  HIERARCHY_LOAD: "HIERARCHY_LOAD",
  HISTORIC_ABSENCE: "HISTORIC_ABSENCE",
  MY_FIRSTCARE_ACCOUNTS: "MY_FIRSTCARE_ACCOUNTS",
  STAFF_IN_POST: "STAFF_IN_POST",
};

export const DATA_FILE_STATUSES = {
  NO_FILE: "NO_FILE",
  PENDING: "PENDING",
  PROCESSED: "PROCESSED",
  CANCELLED: "CANCELLED",
  VALIDATING: "VALIDATING",
  VALIDATION_FAILED: "VALIDATION_FAILED",
  QUEUED: "QUEUED",
  PROCESSING: "PROCESSING",
  PROCESSING_FAILED: "PROCESSING_FAILED",
  COMPLETE: "COMPLETE",
  IN_REVIEW: "IN_REVIEW",
  GENERATING_REVIEW: "GENERATING_REVIEW",
};

export const exceptionGridConfig = {
  HIERARCHY_LOAD: {},
  HISTORIC_ABSENCE: {},
  MY_FIRSTCARE_ACCOUNTS: {},
  STAFF_IN_POST: {},
};

export const DATA_FILE_TYPES_STRINGS = {
  HIERARCHY_LOAD: "Hierarchy Load",
  HISTORIC_ABSENCE: "Historic Absence",
  MY_FIRSTCARE_ACCOUNTS: "My GoodShape Accounts",
  STAFF_IN_POST: "Staff In Post",
};

export const DEFAULT_VALUES_COLUMN_NAMES = {
  "37.5": "37.5_HRS",
  "228": "MISSING_WORKING_DAYS",
  MOVED_TO_UNASSIGNED: "MOVED_TO_UNASSIGNED",
  TODAYS_DATE: "TODAYS_DATE",
  NO_ASSIGNMENT: "NO_ASSIGNMENT",
  CLOSE_ABSENCES: "CLOSE_ABSENCES",
  SET_LEAVE_DATE_AND_MARK_POSITIONS_INACTIVE: "SET_LEAVE_DATE_AND_MARK_POSITIONS_INACTIVE",
};

export const GET_DATA_FILES_FILTERS = [
  {
    name: "status",
    value: DATA_FILE_STATUSES.PENDING,
  },
  {
    name: "status",
    value: DATA_FILE_STATUSES.VALIDATING,
  },
  {
    name: "status",
    value: DATA_FILE_STATUSES.VALIDATION_FAILED,
  },
  {
    name: "status",
    value: DATA_FILE_STATUSES.PROCESSING,
  },
  {
    name: "status",
    value: DATA_FILE_STATUSES.QUEUED,
  },
  {
    name: "status",
    value: DATA_FILE_STATUSES.PROCESSING_FAILED,
  },
  { name: "status", value: DATA_FILE_STATUSES.IN_REVIEW },
  {
    name: "status",
    value: DATA_FILE_STATUSES.GENERATING_REVIEW,
  },
];

export const DATA_MEASURE_STATUSES = {
  GREEN: "GREEN",
  AMBER: "AMBER",
  RED: "RED",
};
